export default __webpack_public_path__ + "static/media/Dead (8).15cfabf1.png";